// extracted by mini-css-extract-plugin
module.exports = {"crmBonus":"_1e5a58e","ownBonus":"_377a522","delimeter":"_b422b36"};